/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chat': {
    width: 16,
    height: 16,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M55.232 43.104C58.354 38.746 60 33.705 60 28.5c0-14.888-13.458-27-30-27S0 13.612 0 28.5s13.458 27 30 27c4.262 0 8.378-.79 12.244-2.348 6.805 3.927 16.212 5.282 16.618 5.338a1 1 0 00.846-1.697c-2.301-2.3-3.885-7.153-4.476-13.689z"/>'
  }
})
